<template>
	<div class="box vh-140">
		<div class="box-header">
			<i class="fa fa-th-large"></i>
			<h3 class="box-title">角色列表</h3>
			<div class="box-tools">
				<el-button size="small" class="pull-right" type="primary" @click="toEditRole()" round><i class="fa fa-plus"></i> 添加角色 </el-button>
			</div>
		</div>
		<div class="box-body">
			<el-table
				class="list-table"
				ref="multipleTable"
				:data="roleList"
				border
				tooltip-effect="dark"
				:header-cell-style="{ background: '#eef1f6', color: '#606266' }"
				@selection-change="handleSelectionChange"
			>
				<template slot="empty">
					<div class="no-data">暂无数据！</div>
				</template>
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column type="index" label="序号" width="60"></el-table-column>
				<el-table-column prop="name" label="角色名" width="240"></el-table-column>
				<el-table-column prop="flag" label="角色标识" width="240"></el-table-column>
				<el-table-column fixed="right" label="操作" min-width="100">
					<template slot-scope="scope">
						<el-button @click.prevent="toEditRole(scope.row.id)" type="text" size="small"><i class="fa fa-edit"></i> 编辑 </el-button>
						<el-button @click.prevent="deleteRole(scope.row.id)" type="text" size="small"><i class="fa fa-trash-o"></i> 删除 </el-button>
						<el-button @click.prevent="roleResource(scope.row)" type="text" size="small"><i class="fa fa-gear"></i> 配置资源 </el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

    <el-dialog :title="isEdit ? '编辑' : '添加'" :visible.sync="dialogVisible" width="480px">
      <el-form :model="roleForm" :rules="rules" ref="roleForm" label-width="80px" size="small">
        <el-form-item label="名称" prop="name">
          <el-input v-model="roleForm.name" placeholder="输入角色名称" style="width: 70%"></el-input>
        </el-form-item>
        <el-form-item label="标识" prop="flag">
          <el-input v-model="roleForm.flag" placeholder="输入角色名称,一般为英文单词" style="width: 70%"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" v-model="roleForm.description"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false"><i class="fa fa-close"></i> 关闭</el-button>
        <el-button size="small" type="primary" @click="saveRole()"><i class="fa fa-save"></i> 保存</el-button>
      </div>
    </el-dialog>

		<!-- 分页-->
		<page-bar v-model="page" @change="fetchData"></page-bar>

    <conf-res :visible="confDrawer" v-model="curRole" ref="confResPage" @done="saveFinish"></conf-res>
	</div>
</template>

<script>
import { fetchList, get, save, update, remove } from '@/api/system/role'
import PageBar from '@components/PageBar'
import ConfRes from '@views/system/ConfRes'
import { handleConfirm } from '@utils/confirm'

export default {
  components: { ConfRes },
  created() {
		this.fetchData()
	},
	component: { PageBar,ConfRes },
	methods: {
		fetchData() {
		  let param = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        query: this.page.param
      }
			fetchList(param).then(resp => {
			  this.$set(this.page,'pageNo',resp.data.pageNo)
			  this.$set(this.page,'pageSize',resp.data.pageSize)
			  this.$set(this.page,'total',resp.data.total)
				this.roleList = resp.data.result.records
			})
		},
		saveRole() {
			this.$refs['roleForm'].validate(valid => {
				if (valid) {
					if (this.isEdit) {
						update(this.roleForm).then(resp => {
							this.submitCallback(resp)
						})
					} else {
						save(this.roleForm).then(resp => {
							this.submitCallback(resp)
						})
					}
				}
			})
		},
		submitCallback(resp) {
			if (resp.status === 200) {
				this.dialogVisible = false
				this.fetchData()
				this.$message.success(resp.data.message)
			}
		},
		roleResource(val) {
		  this.curRole = val
      this.confDrawer = true
      this.$nextTick(() => {
        this.$refs.confResPage.init()
      })
		},
		toEditRole(val) {
			this.dialogVisible = true
			if (val) {
				this.isEdit = true
				get(val).then(resp => {
					this.roleForm = resp.data.result
				})
			} else {
				this.isEdit = false
				this.roleForm = {}
			}
		},
    saveFinish(flag = false){
      this.confDrawer = false
      this.curRole = {}
      if(flag){
        this.fetchData()
      }
    },
		deleteRole(val) {
      handleConfirm('此操作将永久删除, 是否继续?').then(() => {
        remove(val).then(resp => {
          this.submitCallback(resp)
        })
      })
		}
	},
	data() {
		return {
			roleForm: {
				name: '',
				flag: ''
			},
      confDrawer:false,
			rules: {
				name: [
					{ required: true, message: '请输入角色名称', trigger: 'blur' },
					{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
				],
				flag: [{ required: true, message: '请添加角色标识', trigger: 'blur' }]
			},
			page: {
				pageSize: 20,
				pageNo: 1
			},
      curRole:{},
			dialogVisible: false,
			isEdit: false,
			roleList: []
		}
	}
}
</script>
